export const getAgentsList = (state) => state.agents.list;
export const isAgentsListLoading = (state) => state.agents.loadingList;
export const getCurrentAgent = (state) => state.agents.agent;
export const getAgentMessages = (state) => state.agents.messages;
export const getMessagesAgentId = (state) => state.agents.messagesAgentId;
export const isAgentLoading = (state) => state.agents.loadingAgent;
export const isAgentForbidden = (state) => state.agents.forbidden;
export const isAgentSending = (state) => state.agents.sending;
export const getAgentError = (state) => state.agents.error;
// Id da bolha que está sendo preenchida agora; null fora de um stream. Serve
// tanto para saber SE há stream em curso quanto QUAL mensagem é a parcial.
export const getStreamingMessageId = (state) => state.agents.streamingMessageId;
